<app-listado-listado-categorias
  [categorias]="['Sintomas', 'Diagnosticos']"
  tooltipCrear="Crear síntoma o diagnóstico"
  tituloCrear="Crear síntoma o diagnóstico"
></app-listado-listado-categorias>
